import React from 'react';
import browserImage from '../../../assets/confluence-activation/browser1.png';
import browserImageTwo from '../../../assets/confluence-activation/browser2.png';
import browserImageThree from '../../../assets/confluence-activation/browser3.png';
import { FormattedMessage } from 'react-intl-next';
import messages from './messages';
import { Card } from './card';

export const YourProjectPagesInJira = () => (
	<Card
		image={browserImage}
		heading={<FormattedMessage {...messages.yourProjectPagesInJiraTitle} />}
	>
		<FormattedMessage {...messages.yourProjectPagesInJiraDescription} />
	</Card>
);

export const SeamlesslyUpdateStakeholders = () => (
	<Card
		image={browserImageTwo}
		heading={<FormattedMessage {...messages.seamlesslyUpdateStakeholdersTitle} />}
	>
		<FormattedMessage {...messages.seamlesslyUpdateStakeholdersDescription} />
	</Card>
);

export const UnifyDocumentation = () => {
	return (
		<Card
			image={browserImageThree}
			heading={<FormattedMessage {...messages.unifyDocumentationTitle} />}
		>
			<FormattedMessage {...messages.unifyDocumentationDescription} />
		</Card>
	);
};
